/* eslint-disable max-len */
const men = {
  belts: [
    ['STANDARD', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
    ['CM', '65', '70 - 75', '80 - 85', '90 - 95', '100 - 105', '110 - 115', '120'],
    ['INCHES', '26', '28 - 30', '32 - 34', '36 - 38', '40 - 42', '44 - 46', '48'],
  ],

  clothing: [
    ['STANDARD', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'XXXXXL'],
    ['IT/FR', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60'],
    ['US/UK', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50'],
    ['JP', '00', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    ['GER/DAN', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60'],
    ['NUMERICAL', '000', '00', '0', '1', '2', '3', '4', '5', '6', '7', '8'],
    ['ROMAN', '000', '00', '0', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'],
    ['RUS', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60'],
    ['KOREA', '80', '85', '90', '95', '100', '105', '110', '115', '120', '125', '130'],
    [
      'CHINA',
      '155/76A',
      '160/80A',
      '165/84A',
      '170/88A',
      '175/92A',
      '180/96A',
      '185/100A',
      '190/104A',
      '195/108A',
      '200/112A',
      '205/116A',
    ],
    ['LACOSTE', '--', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
  ],

  gloves: [
    ['STANDARD', 'S', 'M', 'L', 'XL'],
    ['CM', '20 - 21.5', '23 - 24', '25.5 - 27', '27.9 - 29.2'],
    ['INCHES', '7.5 - 8', '8.5 - 9', '9.5 - 10', '10.5 - 11'],
  ],
  gloves_notice:
    'To work out your glove size, measure around your hand below the base of your fingers and again from the bottom of your hand to the tip of your middle finger, then choose from the widest measurement.',

  hats: [
    ['STANDARD', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    ['US', '6 ½ - 6 ⅝', '6 ¾ - 6 ⅞', '7 - 7 ⅛', '7 ¼ - 7 ⅜', '7 ½ - 7 ⅝', '7 ¾ - 7 ⅞', '8 - 8 ⅛'],
    ['UK', '6 ⅜ - 6 ½', '6 ⅝ - 6 ¾', '6 ⅞ - 7', '7 ⅛ - 7 ¼', '7 ⅜ - 7 ½', '7 ⅝ - 7 ¾', '7 ⅞ - 8'],
    ['CM', '52 - 53', '54 - 55', '56 - 57', '58 - 59', '60 - 61', '62 - 63', '64 - 65'],
    ['INCHES', '20 ½ - 20 ⅞', '21 ⅛ - 21 ½', '21 ⅞ - 22 ¼', '22 ⅝ - 23', '23 ½ - 23 ⅞', '24 ¼ - 24 ⅝', '25 - 25 ½'],
  ],
  hats_notice: 'To work out your hat size, measure your head across the mid-forehead, where you expect it to sit.',

  jeans: {
    length: [
      ['LEG LENGTH', 'SHORT', 'REGULAR', 'LONG'],
      ['INCHES', '30', '32', '34'],
      ['CM', '76', '81', '86'],
    ],
    waist: [
      ['STANDARD', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
      ['waist', '26 - 27', '28 - 29', '30 - 31', '32 - 33', '34 - 35', '36 - 37', '38 - 39', '40 - 41', '42 - 45'],
    ],
  },

  rings: [
    ['STANDARD', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    ['IT', '1 - 2', '3 - 7', '8 - 12', '13 - 14', '15 - 16', '17 - 18', '19 - 21', '22 - 23'],
    ['FR', '41 - 42', '43 - 47', '48 - 52', '53 - 54', '55 - 56', '57 - 58', '59 - 61', '62 - 63'],
    ['US', '1.5 - 2.25', '2.5 - 4', '4.5 - 6', '6 - 6.5', '7 - 7.5', '8 - 8.5', '9 - 9.5', '10 - 10.25'],
    [
      'UK',
      'B - C - D',
      'E - F - G - H ½ - I',
      'I ½ - J - K - L ½ - M ½',
      'N - O',
      'O ½ - P',
      'Q - Q ½',
      'R - S - T',
      'T ½ - U',
    ],
    [
      'MM',
      '13.00 - 13.30',
      '13.60 - 14.00 - 14.30 - 14.60 - 14.90',
      '15.30 - 15.56 - 16.00 - 16.25 - 16.56',
      '16.90 - 17.20',
      '17.52 - 17.83',
      '18.15 - 18.47',
      '18.79 - 19.11 - 19.43',
      '19.74 - 20.06',
    ],
    [
      'INCHES',
      '0.51 - 0.52',
      '0.53 - 0.55 - 0.56 - 0.57 - 0.59',
      '0.60 - 0.61 - 0.63 - 0.64 - 0.65',
      '0.66 - 0.68',
      '0.69 - 0.70',
      '0.71 - 0.73',
      '0.74 - 0.75 - 0.76',
      '0.78 - 0.79',
    ],
  ],

  shirts: [
    ['STANDARD', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
    ['COLLAR (cm)', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45'],
    ['COLLAR (inches)', '14', '14 ½', '15', '15 ½', '16', '16 ½', '17', '17 ½', '18', '18 ½'],
  ],

  shoes: [
    [
      'IT',
      '36',
      '36.5',
      '37',
      '37.5',
      '38',
      '38.5',
      '39',
      '39.5',
      '40',
      '40.5',
      '41',
      '41.5',
      '42',
      '42.5',
      '43',
      '43.5',
      '44',
      '44.5',
      '45',
      '45.5',
      '46',
      '46.5',
      '47',
      '47.5',
      '48',
      '48.5',
    ],
    [
      'US',
      '3',
      '3.5',
      '4',
      '4.5',
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
      '11.5',
      '12',
      '12.5',
      '13',
      '13.5',
      '14',
      '14.5',
      '15',
      '15.5',
    ],
    [
      'UK',
      '2',
      '2.5',
      '3',
      '3.5',
      '4',
      '4.5',
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
      '11.5',
      '12',
      '12.5',
      '13',
      '13.5',
      '14',
      '14.5',
    ],
    [
      'JP',
      '21',
      '21.5',
      '22',
      '22.5',
      '23',
      '23.5',
      '24',
      '24.5',
      '25',
      '25.5',
      '26',
      '26.5',
      '27',
      '27.5',
      '28',
      '28.5',
      '29',
      '29.5',
      '30',
      '30.5',
      '31',
      '31.5',
      '32',
      '32.5',
      '33',
      '33.5',
    ],
    [
      'KOREA',
      '210',
      '215',
      '220',
      '225',
      '230',
      '235',
      '240',
      '245',
      '250',
      '255',
      '260',
      '265',
      '270',
      '275',
      '280',
      '285',
      '290',
      '295',
      '300',
      '305',
      '310',
      '315',
      '320',
      '325',
      '330',
      '335',
    ],
    [
      'ADIDAS EU',
      '--',
      '--',
      '36',
      '36 ⅔',
      '37 ⅓',
      '38',
      '38 ⅔',
      '39 ⅓',
      '40',
      '40 ⅔',
      '41 ⅓',
      '42',
      '42 ⅔',
      '43 ⅓',
      '44',
      '44 ⅔',
      '45 ⅓',
      '46',
      '46 ⅔',
      '47 ⅓',
      '48',
      '48 ⅔',
      '49 ⅓',
      '50',
      '50 ⅔',
      '--',
    ],
  ],
};

const women = {
  belts: [
    ['STANDARD', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
    ['CM', '60 - 65', '70 - 75', '80 - 85', '90 - 95', '100 - 105', '110 - 115', '120', '125'],
    ['INCHES', '24 - 26', '28 - 30', '32 - 34', '36 - 38', '40 - 42', '44 - 46', '48', '50'],
    ['IT', '36', '38', '40', '42', '44', '46', '48', '50'],
  ],

  clothing: [
    ['STANDARD', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    ['IT', '36', '38', '40', '42', '44', '46', '48', '50', '52'],
    ['FR', '32', '34', '36', '38', '40', '42', '44', '46', '48'],
    ['US', '0', '2', '4', '6', '8', '10', '12', '14', '16'],
    ['UK', '4', '6', '8', '10', '12', '14', '16', '18', '20'],
    ['JP', '3', '5', '7', '9', '11', '13', '15', '17', '19'],
    ['GER/DAN', '30', '32', '34', '36', '38', '40', '42', '44', '46'],
    ['NUMERICAL', '000', '00', '0', '1', '2', '3', '4', '5', '6'],
    ['ROMAN', '000', '00', '0', 'I', 'II', 'III', 'IV', 'V', 'VI'],
    ['RUS', '38', '40', '42', '44', '46', '48', '50', '52', '54'],
    ['KOREA', '--', '33', '44', '55', '66', '77', '88', '99', '--'],
    ['CHINA', '145/73A', '150/76A', '155/80A', '160/84A', '165/88A', '170/92A', '175/96A', '180/10A', '185/104A'],
    ['AUS', '4', '6', '8', '10', '12', '14', '16', '18', '20'],
  ],

  gloves: [
    ['STANDARD', 'XS', 'S', 'M', 'L', 'XL'],
    ['CM', '16', '17.5', '19 - 20', '21.5', '23 - 24'],
    ['INCHES', '6', '6.5', '7 - 7.5', '8', '8.5 - 9'],
  ],
  gloves_notice:
    'To work out your glove size, measure around your hand below the base of your fingers and again from the bottom of your hand to the tip of your middle finger, then choose from the widest measurement.',

  hats: [
    ['STANDARD', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    ['UK', '6 ⅜ - 6 ½', '6 ⅝ - 6 ¾', '6 ⅞ - 7', '7 ⅛ - 7 ¼', '7 ⅜ - 7 ½', '7 ⅝ - 7 ¾', '7 ⅞ - 8'],
    ['US', '6 ½ - 6 ⅝', '6 ¾ - 6 ⅞', '7 - 7 ⅛', '7 ¼ - 7 ⅜', '7 ½ - 7 ⅝', '7 ¾ - 7 ⅞', '8 - 8 ⅛'],
    ['CM', '52 - 53', '54 - 55', '56 - 57', '58 - 59', '60 - 61', '62 - 63', '64 - 65'],
    ['INCHES', '20 ½ - 20 ⅞', '21 ⅛ - 21 ½', '21 ⅞ - 22 ¼', '22 ⅝ - 23', '23 ½ - 23 ⅞', '24 ¼ - 24 ⅝', '25 - 25 ½'],
  ],
  hats_notice: 'To work out your hat size, measure your head across the mid-forehead, where you expect it to sit.',

  jeans: {
    length: [
      ['LEG LENGTH', 'SHORT', 'REGULAR', 'LONG'],
      ['CM', '76', '81', '86'],
      ['INCHES', '30', '32', '34'],
    ],
    waist: [
      ['STANDARD', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      ['waist', '23', '24 - 25', '26 - 27', '28 - 29', '30 - 31', '32 - 33', '34 - 35', '36 - 37', '38 - 40'],
    ],
  },

  rings: [
    ['STANDARD', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    ['IT', '1 - 2', '3 - 7', '8 - 12', '13 - 14', '15 - 16', '17 - 18', '19 - 21', '22 - 23'],
    ['FR', '41 - 42', '43 - 47', '48 - 52', '53 - 54', '55 - 56', '57 - 58', '59 - 61', '62 - 63'],
    ['US', '1.5 - 2.25', '2.5 - 4', '4.5 - 6', '6 - 6.5', '7 - 7.5', '8 - 8.5', '9 - 9.5', '10 - 10.25'],
    [
      'UK',
      'B - C - D',
      'E - F - G - H ½ - I',
      'I ½ - J - K - L ½ - M ½',
      'N - O',
      'O ½ - P',
      'Q - Q ½',
      'R - S - T',
      'T ½ - U',
    ],
    [
      'MM',
      '13.00 - 13.30',
      '13.60 - 14.00 - 14.30 - 14.60 - 14.90',
      '15.30 - 15.56 - 16.00 - 16.25 - 16.56',
      '16.90 - 17.20',
      '17.52 - 17.83',
      '18.15 - 18.47',
      '18.79 - 19.11 - 19.43',
      '19.74 - 20.06',
    ],
    [
      'INCHES',
      '0.51 - 0.52',
      '0.53 - 0.55 - 0.56 - 0.57 - 0.59',
      '0.60 - 0.61 - 0.63 - 0.64 - 0.65',
      '0.66 - 0.68',
      '0.69 - 0.70',
      '0.71 - 0.73',
      '0.74 - 0.75 - 0.76',
      '0.78 - 0.79',
    ],
  ],

  shoes: [
    [
      'IT',
      '34',
      '34.5',
      '35',
      '35.5',
      '36',
      '36.5',
      '37',
      '37.5',
      '38',
      '38.5',
      '39',
      '39.5',
      '40',
      '40.5',
      '41',
      '41.5',
      '42',
      '42.5',
      '43',
      '43.5',
      '44',
    ],
    [
      'US',
      '4',
      '4.5',
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
      '11.5',
      '12',
      '12.5',
      '13',
      '13.5',
      '14',
    ],
    [
      'UK',
      '1',
      '1.5',
      '2',
      '2.5',
      '3',
      '3.5',
      '4',
      '4.5',
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
    ],
    [
      'FR',
      '35',
      '35.5',
      '36',
      '36.5',
      '37',
      '37.5',
      '38',
      '38.5',
      '39',
      '39.5',
      '40',
      '40.5',
      '41',
      '41.5',
      '42',
      '42.5',
      '43',
      '43.5',
      '44',
      '44.5',
      '45',
    ],
    [
      'JP',
      '21',
      '21.5',
      '22',
      '22.5',
      '23',
      '23.5',
      '24',
      '24.5',
      '25',
      '25.5',
      '26',
      '26.5',
      '27',
      '27.5',
      '28',
      '28.5',
      '29',
      '29.5',
      '30',
      '30.5',
      '31',
    ],
    [
      'KOREA',
      '210',
      '215',
      '220',
      '225',
      '230',
      '235',
      '240',
      '245',
      '250',
      '255',
      '260',
      '265',
      '270',
      '275',
      '280',
      '285',
      '290',
      '295',
      '300',
      '305',
      '310',
    ],
    [
      'CHINA',
      '34',
      '34.5',
      '35',
      '35.5',
      '36',
      '36.5',
      '37',
      '37.5',
      '38',
      '38.5',
      '39',
      '39.5',
      '40',
      '40.5',
      '41',
      '41.5',
      '42',
      '42.5',
      '43',
      '43.5',
      '44',
    ],
    [
      'ADIDAS EU',
      '--',
      '--',
      '36',
      '36 ⅔',
      '37 ⅓',
      '38',
      '38 ⅔',
      '39 ⅓',
      '40',
      '40 ⅔',
      '41 ⅓',
      '42',
      '42 ⅔',
      '43 ⅓',
      '44',
      '44 ⅔',
      '45 ⅓',
      '46',
      '46 ⅔',
      '47 ⅓',
      '48',
    ],
  ],
};

const juniorKids = {
  clothing: [
    ['AGE (YRS)', '2', '3', '4', '5', '6', '8', '10', '12'],
    ['HEIGHT (IN)', '33 - 36', '36 - 39', '39 - 41', '41 - 43', '43 - 46', '46 - 50', '50 - 55', '55 - 60'],
    [
      'HEIGHT (CM)',
      '84 - 92',
      '92 - 100',
      '100 - 105',
      '105 - 110',
      '110 - 117',
      '117 - 127',
      '127 - 140',
      '140 - 152',
    ],
  ],
  shoes: [
    ['AGE (YRS)', '2', '2', '3', '3', '4', '5', '6', '7', '8', '8', '9', '10', '11', '12'],
    ['EU', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36'],
    [
      'US',
      '7k',
      '7.5k',
      '8 - 8.5k',
      '9 - 9.5k',
      '10 - 10.5k',
      '11k',
      '11.5 - 12k',
      '12.5k ',
      '13 - 13.5k ',
      '1',
      '1.5 - 2',
      '2.5 - 3',
      '3 - 3.5',
      '4 - 4.5',
    ],
    [
      'UK',
      '6 - 6.5k',
      '7k',
      '7.5 - 8k',
      '8.5k',
      '9 - 9.5k',
      '10 - 10.5k',
      '11k',
      '11.5k ',
      '12 - 12.5k',
      '13 - 13.5k',
      '1',
      '1.5 - 2',
      '2.5',
      '3 - 3.5',
    ],
    [
      'FOOT LENGTH (IN)',
      '5.5 - 5.75',
      '5.75 - 6',
      '6 - 6.25',
      '6.25 - 6.5',
      '6.5 - 6.75',
      '6.75 - 7',
      '7 - 7.25',
      '7. 25 - 7.5',
      '7.5 - 7.75',
      '7.75 - 8',
      '8 - 8.25',
      '8.25 - 8.5',
      '8.5 - 8.75',
      '8.75 - 9.25',
    ],
    [
      'FOOT LENGTH (CM)',
      '14 - 14.5',
      '14.5 - 15.25',
      '15.25 - 15.75',
      '15.75 - 16.5',
      '16.5 - 17',
      '17 - 17.75',
      '17.75 - 18.5',
      '18.5 - 19',
      '19 - 19.5',
      '19.5 - 20.25',
      '20.25 - 21',
      '21 - 21.5',
      '21.5 - 22.25',
      '22.25 - 23.5',
    ],
  ],
  belts: [
    ['AGE (YRS)', '2-3', '3-4', '4-5', '5-6', '6-7', '7-8', '8-9', '9-10', '10-11', '11-12'],
    [
      'WAIST (IN)',
      '19 - 20',
      '20 - 21',
      '21 - 22',
      '22 - 23',
      '23 - 23.5',
      '23.5 - 24.5',
      '24.5 - 25',
      '25 - 26',
      '26 - 27',
      '27 - 27.5',
    ],
    [
      'WAIST (CM)',
      '50 - 52',
      '52 - 54',
      '54 - 56',
      '56 - 58',
      '58 - 60',
      '60 - 62',
      '62 - 64',
      '64 - 66',
      '66 - 68',
      '68 - 70',
    ],
  ],
  hats: [
    ['AGE (YRS)', '3-6', '6-9', '9-12'],
    ['CIRCUMFERENCE (IN)', '19 - 19.75', '19.75 - 20.5', '20.5 - 21.25'],
    ['CIRCUMFERENCE (CM)', '48 - 50', '50 - 52', '52 - 54'],
  ],
};

const babyKids = {
  clothing: [
    ['AGE (M)', '1', '3', '6', '9', '12', '18', '24', '36'],
    ['DUAL AGE (M)', '0-1', '1-3', '3-6', '6-9', '9-12', '12-18', '18-24', '24-36'],
    ['HEIGHT (IN)', '19 - 22', '22 - 25', '25 - 28', '28 - 30', '30 - 32', '32 - 35', '35 - 37', '37 - 40'],
    ['HEIGHT (CM)', '48 - 57', '57 - 63', '63 - 68', '68 - 75', '75 - 80', '80 - 86', '86 - 92', '92 - 100'],
  ],
  shoes: [
    ['AGE (M)', '0-3 M', '3-6 M', '6-9 M', '9-12 M', '12-18 M', '18-24 M', '24-36 M'],
    ['EU', '16', '17', '18', '19', '20', '21', '22'],
    ['US', '1k', '2k', '2.5 - 3k', '3.5k', '4 - 4.5k', '5 - 5.5k', '6 - 6.5k'],
    ['UK', '0k', '1k', '1.5 - 2k', '2.5 - 3k', '3.5 - 4k', '4.5 - 5k', '5.5k'],
    ['FOOT LENGTH (IN)', '3.5 - 4', '4 - 4.25', '4.25 - 4.5', '4.5 - 4.75', '4.75 - 5', '5 - 5.25', '5.25 - 5.5'],
    ['FOOT LENGTH (CM)', '7 - 9', '9 - 11', '11 - 12', '12 - 13', '13 - 13.5', '13.5 - 14', '14.5 - 15'],
  ],
  hats: [
    ['AGE (M)', '0-6 M', '6-12 M', '12-24 M'],
    ['CIRCUMFERENCE (IN)', '15.5 - 17.25', '17.25 - 19', '19 - 19.75'],
    ['CIRCUMFERENCE (CM)', '38 - 44', '44 - 48', '48 - 50'],
  ],
};

export { men, women, babyKids, juniorKids };
